(ns hypnos.consumer.panels.nav-bar
  "The backoffice main navigation bar."
  (:require [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; panel

(defn panel
  "The navigation bar"
  []
  (let [subdomain (rf/subscribe [:consumer/subdomain])]
    [:nav.navbar.is-fixed-top
     [:div.navbar-brand
      (if @subdomain
        [:img {:src (str "/images/logo_" @subdomain ".png") :alt @subdomain :height "30"}]
        [:img {:src "/images/logo_irissleep.png" :alt "irisSleep" :height "30"}])]]))
